import { useFormik } from 'formik';
import { FraudModeParamsDataProps } from './props';
import { useEffect } from 'react';
import { ISelect } from '../../../../../../shared/types/shared';

export const useFraudModeData = ({ data }: FraudModeParamsDataProps) => {
    const formik = useFormik({
        initialValues: {
            name: '',
            active: false,
            extra: '',
            valueSmart: '',
            parent: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('active', data?.active || false);
        formik?.setFieldValue('extra', data?.extra || '');
        formik?.setFieldValue('valueSmart', data?.valueSmart || '');
        formik?.setFieldValue('parent', (data?.parent as ISelect)?.name || '');
    }, [data]);

    return {
        formik,
    };
};
